export const STAT_ICON_MAP: { [key: string]: string } = {
  startedAt: 'time',
  duration: 'stopwatch',
  objectsSuccess: 'circle-tick',
  objectsQueued: 'load-status',
  objectsFailed: 'error-outline',
  eventsIngested: 'ingested',
  eventsLoaded: 'loaded',
  eventsFailed: 'error-outline',
  billableEvents: 'billable',
  nonBillableEvents: 'non-billable',
  latency: 'hourglass-25'
};
